import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import settings from './settings';
import auth from './auth';
import context from './context';

const reducers = {
  routing: routerReducer,
  context,
  settings,
  auth
};

export default combineReducers(reducers);
